import { schema } from "normalizr";
import { Company } from "./company";

export const Companies = new schema.Array(Company);
